export const ROLES = {
  admin: 'ADMIN',
  recruiter: 'RECRUITER'
};

export const hasRole = (role, roles = []) => roles.some(r => `${r}`.toUpperCase() === role.toUpperCase());

// Connect migration: CollaboratorProfile carries no `groups`. Scopes and recruiter
// permissions now come from the profile alone — read/write workspaces as plain
// lists, permissions from the single consolidated `permissions` ProfileObject.
export const mergeCollaboratorScopes = (data = {}) => {
  const readWorkspaces = [...(data.readWorkspaces || [])];
  const writeWorkspaces = [...(data.writeWorkspaces || [])];
  const permissions = [...(data.permissions?.recruiter || [])];

  // (data.groups || []).forEach(group => {
  //   readWorkspaces.push(...(group.readWorkspaces || []));
  //   writeWorkspaces.push(...(group.writeWorkspaces || []));
  //   permissions.push(...(group.permissions?.recruiter || []));
  // });

  return {
    readWorkspaces: [...new Set(readWorkspaces)],
    writeWorkspaces: [...new Set(writeWorkspaces)],
    permissions: [...new Set(permissions.map(p => `${p}`.toUpperCase()))]
  };
};

export const hasWorkspaceAccess = (workspace, workspaces = [], email = '') => {
  if (!workspace) return false;

  if (workspace === 'test_workspace' && !email.endsWith('@webtales.fr')) {
    return false;
  }

  return workspaces.includes('*') || workspaces.includes(workspace);
};
